import { loading, error, filters } from '../state'
import { suggestionsService } from '../../../services/suggestions/suggestions-service'
import { useAssetStore } from '@/stores'

/**
 * Öneri verilerini doğrular
 * @param {Object} suggestionData - Doğrulanacak öneri verileri
 * @returns {boolean} Doğrulama sonucu
 */
const validateSuggestionData = (suggestionData) => {
  if (suggestionData.contentId === undefined || suggestionData.contentId === null) {
    throw new Error('İçerik ID zorunludur')
  }
  return true
}

/**
 * Öneri verilerini işlemden geçirir
 * @param {Object} suggestionData - İşlenecek öneri verileri
 * @returns {Object} İşlenmiş öneri verileri
 */
const processSuggestionData = (suggestionData, assetId) => {
  const processedData = { ...suggestionData }

  // contentId string dönüştürme
  processedData.contentId = String(processedData.contentId)

  // AssetId ekle
  processedData.assetId = assetId

  return processedData
}

/**
 * API yanıtını işler
 * @param {Object} response - API'den gelen yanıt
 * @returns {Object|null} İşlenmiş veri veya null
 */
const handleApiResponse = (response) => {  
  if (response.success && response.data) {
    return response.data
  } else {
    throw new Error(response.message || 'Öneri oluşturulurken bir hata oluştu')
  }
}

/**
 * Yeni bir öneri oluşturur
 * @param {Object} suggestionData - Öneri verileri
 * @returns {Promise<Object|null>} Oluşturulan öneri veya null
 */
export const createSuggestion = async (suggestionData) => {
  try {
    // Store'dan assetId'yi al - Fonksiyon içinde çağırıyoruz!
    const assetStore = useAssetStore()
    const assetId = assetStore.assetId
    
    loading.value = true
    error.value = null

    // Verileri doğrula
    validateSuggestionData(suggestionData)

    // Verileri işle
    const processedData = processSuggestionData(suggestionData, assetId)

    // API isteği gönder
    const response = await suggestionsService.createSuggestion(processedData)

    // Yanıtı işle
    return handleApiResponse(response)

  } catch (err) {
    console.error('Error creating suggestion:', err)
    error.value = err.message || 'Öneri oluşturulurken bir hata oluştu'
    throw err
  } finally {
    loading.value = false
  }
}